import React from "react";
import Link from "next/link";
import { docsColors } from "@/lib/docs-theme";

export interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface DocBreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function DocBreadcrumb({ items }: DocBreadcrumbProps) {
  return (
    <nav className="mb-8">
      <ol className="flex items-center space-x-2 text-sm">
        {items.map((item, index) => (
          <React.Fragment key={index}>
            {index > 0 && <li className={docsColors.text.subtle}>/</li>}
            <li>
              {item.href ? (
                <Link href={item.href} className={docsColors.link.muted}>
                  {item.label}
                </Link>
              ) : (
                <span className={docsColors.text.heading}>{item.label}</span>
              )}
            </li>
          </React.Fragment>
        ))}
      </ol>
    </nav>
  );
}
